import NavHeader from "../shared/Nav-Header";
import { useState, useEffect, useMemo } from "react";
import styles from './club-profile.module.css';
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import Notification from '../shared/Notification';
import SocialMessageBox from '../shared/SocialMessageBox';
import defaultProfile2 from '../images/default-profile2.jpg';
import { GROUPAVATARS } from '../shared/avatars/GroupAvatars';
// import defaultClubImage1 from '../images/clubs/club-1.png';
import defaultClubImage2 from '../images/clubs/club-1.png'
import { EditIcon, GroupMessageIcon } from '../shared/icons/Icons';
import {formatDistanceToNow, set} from 'date-fns';
import { CopyLinkIcon, LeaveGroupIcon, ReportIcon, DeleteIcon } from '../shared/icons/Icons';
import { useAuth } from '../context/AuthContext';
import SocialSearch from '../shared/SocialSearch';


const ClubProfile = () => {
    const {clubId} = useParams();
    const [club, setClub] = useState();
    const { userId } = useAuth();
    const [activeClubChat, setActiveClubChat] = useState(null);
    const [notification, setNotification] = useState('');
    const navigate = useNavigate();
    const [leaveClubPopup, setLeaveClubPopup] = useState(false);
    const [deleteClubPopup, setDeleteClubPopup] = useState(false);
    const [projectNetworkList, setProjectNetworkList] = useState([]);
    const [showAddMembers, setShowAddMembers] = useState(false);
    const [selectedNetworks, setSelectedNetworks] = useState([]);
    const [availableNetworks, setAvailableNetworks] = useState([]);
    const [createdDate,setCreatedDate] = useState('');
    const [clubProfilePicturePopup, setClubProfilePicturePopup] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [closeButton,setCloseButton]= useState(false);
    const [selectedAvatar, setSelectedAvatar] = useState(GROUPAVATARS[0]);
    const [editing, setEditing] = useState(false);
    const [clubProfilePictureView, setClubProfilePictureView] = useState(false);
    const [showOptions, setShowOptions] = useState(null);
    const [membership, setMembership] = useState('');
    const [leftClubMembers, setLeftClubMembers] = useState([])
    // console.log('club',club)
    const [reportClubPopup, setReportClubPopup] = useState(false);
    const [reportClubId, setReportClubId] = useState(null);
    const [reportMessage, setReportMessage] = useState('');
    const token = useMemo(() => localStorage.getItem('token'), []);
    const socialType = 'club';

    useEffect(() => {
        const fetchClubDetails = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }
                const response = await axios.get(`/api/club/club-details/${clubId}`, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log("Club Details Response:", response.data.club);
                setMembership(response.data.membershipStatus);
                setClub(response.data.club);
                setCreatedDate(formatDistanceToNow(new Date(response.data.club.createdAt), {addSuffix: true}))
            }
            catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching club details';
                // console.error(errorMessage);
                setNotification(errorMessage || 'Error fetching club details. Please try again.');
            }
        };
        fetchClubDetails();
    }, [membership]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (!token) {
                    localStorage.setItem('notification', 'You are currently Logged-out, Please login !');
                    navigate('/login');
                    return;
                }

                const response = await axios.get('/api/pn/my-networks', {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                // console.log("response.data", response.data);
                const projectNetworkList = response.data;
                setProjectNetworkList(projectNetworkList);
                setAvailableNetworks(club ? projectNetworkList.filter(network => !club.participants.some(participant => participant._id === network._id)) : projectNetworkList);
                // console.log("Available Networks:1", availableNetworks);
                // console.log("club:1", club.participants.map(p => p.name));

                // console.log('Project Network List:', projectNetworkList);
            } catch (error) {
                const errorMessage = error.response?.data?.message || 'Error fetching project networks data';
                console.error(errorMessage);
                setNotification(errorMessage ||'Error fetching project networks data. Please try again.');
            }
        };
        fetchData();
    }, [showAddMembers]);

    // useEffect(() => {
    //     if (membership === 'left') {
    //         const fetchLeftClubMembers =async() =>{
    //             try {
    //                 const response = await axios.get(`/api/club/left-club-members/${club._id}`, {
    //                     headers: {
    //                         Authorization: `Bearer ${localStorage.getItem('token')}`
    //                     }
    //                 });
    //                 setLeftClubMembers(response.data.members);
    //                 // console.log("leftClubMembers:", response.data.members);
    //             }
    //             catch (error) {
    //                 const errorMessage = error.response?.data?.message || 'Error fetching left club members data';
    //                 // console.error(errorMessage);
    //                 setNotification('Error fetching left club members data. Please try again.');
    //             }
    //         }
    //         fetchLeftClubMembers();
    //     }
    // }, [membership]);

    const handleClubChatClick = async (club) => {
        if(activeClubChat){
            setActiveClubChat(null);
        }
        else{
            setActiveClubChat(club);
        }
    };
    const handleLeaveClubClick = async (club) => {
        setLeaveClubPopup(true);
    };
    
    const handleDeleteClubClick = async (club) => {
        setDeleteClubPopup(true);
    };

    const handleAddMembers = async (clubId) => {
        if(selectedNetworks.length === 0) {
            setNotification('Please select at least one member to add.');
            return;
        }
        try {
            const response = await axios.post('/api/club/add-members', {
                clubId,
                userIdsToAdd: selectedNetworks 
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            
            if (response.data.success) {
                setNotification(response.data.message || 'Member(s) Added successfully!');
                setClub(response.data.club);
                setSelectedNetworks([])
                setShowAddMembers(false);
                console.log("Updated Club after adding members:", response.data.club);
            }
        } catch (error) {
            // console.error('Error adding members:', error);
            const errorMessage = error.response?.data?.message || 'Error adding members. Please try again.';
            setNotification(errorMessage);
        }
    };
    const handleSelectNetwork = async (event, networkId) => {
        event.stopPropagation();
        setSelectedNetworks((prevSelected) => {
            if (prevSelected.includes(networkId)) {
                return prevSelected.filter(id => id !== networkId);
            } else {
                return [...prevSelected, networkId];
            }
        });
    };

    const handleJoinClub = async (clubId) => {
        try {
            const response = await axios.post('/api/club/join-club', {
                clubId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.data.success) {
                setNotification(response.data.message || 'Joined Club successfully!');
                setClub(response.data.club);
                setMembership('member');
            }
        } catch (error) {
            // console.error('Error joining club:', error);
            const errorMessage = error.response?.data?.message || 'Error joining club. Please try again.';
            setNotification(errorMessage);
        }
    };

    const handleRemoveMember = async (clubId, _id) => {
        try {
            const response = await axios.post('/api/club/remove-member', {
                clubId,
                userIdToRemove:_id
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Member Removed Successfully!');
                setClub(response.data.club);
                // console.log("Updated Club after removal:", response.data.club);
                setAvailableNetworks(response.data.club ? projectNetworkList.filter(network => !response.data.club.participants.some(participant => participant._id === network._id)) : projectNetworkList);
            }
        } catch (error) {
            // console.error('Error removing member:', error);
            const errorMessage = error.response?.data?.message || 'Error removing member. Please try again.';
            setNotification(errorMessage);
        }
    };
    const handleLeaveClub = async (clubId) => {
        try {
            const response = await axios.post('/api/club/leave-club', {
                clubId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Club Left successfully!');
                setMembership('left');
            }
        } catch (error) {
            // console.error('Error leaving club:', error);
            const errorMessage = error.response?.data?.message || 'Error leaving club. Please try again.';
            setNotification(errorMessage);
        }
    };
    const handleDeleteClub = async (clubId) => {
        try {
            const response = await axios.post('/api/club/delete-club', {
                clubId,
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.data.success) {
                setNotification(response.data.message || 'Club Deleted successfully!');
            }
        } catch (error) {
            // console.error('Error leaving club:', error);
            const errorMessage = error.response?.data?.message || 'Error deleting club. Please try again.';
            setNotification(errorMessage);
        }
    };

    const confirmDeleteClub = () => {
        if (club && club._id) {
            handleDeleteClub(club._id);
        }
        setDeleteClubPopup(false);
    };
    const cancelDeleteClub = () => {
        setDeleteClubPopup(false);
    };

    const handleCloseChat = () => {
        setActiveClubChat(null);
    };
    const handleCloseNotification = () => {
        setNotification('');
    };

    const confirmLeaveClub = () => {
        if (club && club._id) {
            handleLeaveClub(club._id);
        }
        setLeaveClubPopup(false);
    };
    const cancelLeaveClub = () => {
        setLeaveClubPopup(false);
    };

    const handleBack = () => {
        navigate(-1);
    }
    const handleShowAddMembers= () => {
        if(showAddMembers) {
            setShowAddMembers(false);
        } else {
            setShowAddMembers(true);
        }
    };

    const handleSaveClubInfo = async () => {
        try {
            const response = await axios.post('/api/club/update-club-info', {
                clubId: club._id,
                description: club?.description || "",
                name: club.name
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            if (response.data.success) {
                setNotification(response.data.message || 'Club Info Updated successfully!');
                setClub(response.data.club);
            }
        } catch (error) {
            const errorMessage = error.response?.data?.message || 'Error updating club info. Please try again.';
            setNotification(errorMessage);
            // console.error('Error updating club info:', error);
        }
    };
    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (editing) {
                event.preventDefault();
                event.returnValue = 'You have unsaved changes. Do you want to leave?';
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [editing]);
    const handleClubProfilePictureClick =() =>{
        // event.stopPropagation(); // यह event को bubble होने से रोकेगा
        setClubProfilePictureView(!clubProfilePictureView);
    }
    const handleClubProfilePictureEdit = () => {
        setClubProfilePicturePopup(!clubProfilePicturePopup);
        setClubProfilePictureView(false);
    }
    const handleClickOutside = (event) => {
        if (!event.target.closest(`.${styles.top}`) && 
        !event.target.closest(`.${styles.bottom}`)) {
        setClubProfilePictureView(false);
    }
    };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, [clubProfilePictureView]);
    const handleProfilePictureSelect = async (selectedPicture) => {
        setClub((prevClub) => ({
            ...prevClub,
            profilePicture: selectedPicture
        }));
        setSelectedAvatar(selectedPicture);
        // console.log("selectedPicture:", selectedPicture);

        //preset-upload route
        try{
            const response = await axios.post('/api/club/update-profile-picture', {
                clubId: club._id,
                profilePicture: selectedPicture
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            if (response.data.success) {
                setNotification(response.data.message || 'Club Profile Picture Updated successfully!');
                setClub(response.data.club);
                // console.log("Updated Club after profile picture update:", response.data.club);
            }
        } catch (error) {
            const errorMessage = error.message || 'Error updating club profile picture. Please try again.11';
            setNotification(errorMessage);
            // console.error('Error updating profile picture:', error);
        }
        setClubProfilePicturePopup(false);
    }
    const handleProfileClick = async (networkId) => {
        const profileStatus = 'friends';
        // console.log("profileStatus:hp", profileStatus);
        // setStatus(profileStatus)
        // console.log("status:hp",status)
        navigate(`/profile/${networkId}`, { state: profileStatus });  
    };

    const handleCopyInviteLink = async (e, clubId) => {
        e.preventDefault();
        e.stopPropagation();
        
        try {
            const response = await axios.post('/api/club/invite-link', 
                { clubId },
                { headers: { Authorization: `Bearer ${token}` } }
            );

            if (response.data.success) {
                const inviteLink = response.data.inviteLink;
                
                await navigator.clipboard.writeText(inviteLink);
                
                const expiresAt = new Date(response.data.expiresAt);
                const now = new Date();
                const daysLeft = Math.ceil((expiresAt - now) / (1000 * 60 * 60 * 24));
                
                setNotification(`Invite link copied to clipboard! Valid for ${daysLeft} days.`);
            }
        } catch (err) {
            // console.error('Error generating invite link:', err);
            setNotification(err.response?.data?.message || 'Failed to generate invite link. Please try again.');
        }
    };
    
    const handleReportClub = async (e, clubId) => {
        e.preventDefault();
        e.stopPropagation();            
        try{
            await axios.post('/api/club/report-club', {
                clubId: clubId,
                reportMessage: reportMessage
            }, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });
            setReportClubPopup(false);
            setNotification('Club reported. Our team will review it shortly.');
        }
        catch (error) {
            // console.error('Error reporting club:', error);
            const errorMessage = error.response?.data?.message || 'Error reporting club. Please try again.';
            setNotification(errorMessage);
        }
        
    }
    const handleReportClubPopup = (clubId) => {
        setReportClubPopup(true);
        setReportClubId(clubId);
    };
    const cancelReportClub = () => {
        setReportClubPopup(false);
    };
    const handleClubOptions = () => {
        if (showOptions === true) {
            setShowOptions(false);
        } else {
            setShowOptions(true);
        }
    };
    const handleClickOutside2 = (event) => {
            if (!event.target.closest(`.${styles.clubItem}`) && !event.target.closest(`.${styles.messageOptionsMenu}`)) {
                setShowOptions(null);
            }
        };
    useEffect(() => {
        document.addEventListener('click', handleClickOutside2);
        return () => {
            document.removeEventListener('click', handleClickOutside2);
        };
    }, []);

    const handleUpload = async (e, type) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append('file', file);
        formData.append('upload_preset', 'ml_default'); // Replace with your Cloudinary upload preset

        setUploading(true);
        setCloseButton(true);
        try {
            const uploadResponse = await axios.post('/api/upload/upload-all', formData, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    'Content-Type': 'multipart/form-data'
                }
            });
            const url = uploadResponse.data.url;

            setClub((prevClub) => ({
                ...prevClub,
                profilePicture: url
            }));

                const response = await axios.post('/api/club/update-profile-picture', {
                    clubId: club._id,
                    profilePicture: url
                }, {
                    headers: {
                        Authorization: `Bearer ${token}`
                    }
                });
                //custom upload route
                if (response.data.success) {
                    setNotification(response.data.message || 'Custom profile picture uploaded successfully!');
                    setClub(response.data.club);
                }
                
                setUploading(false);
                setCloseButton(false);
                setClubProfilePicturePopup(false);

            } catch (error) {
                // console.error('Error uploading file:', error);
                const errorMessage = error.response?.data?.message || 'Error uploading file. Please try again.';
                setNotification(errorMessage);
                setUploading(false);
            }
        };
    
//    console.log("clubparticipats", club?.participants.map( _id => _id.name));
    //             console.log("Available Networks:2", availableNetworks);
        // console.log("club.admin:", club?.admin, "userId:", userId);
        // console.log("membership:", membership);
    return (
        <div>
            <NavHeader />
            <br/><br/>
            <br/><br/>
            {notification && (
                    <Notification message={notification} onClose={handleCloseNotification} />
                )}
            {membership == 'member'&&(
                <>
                {club &&
                    <div className={styles.clubProfileContainer}>
                        <h1>Club Profile</h1>
                        <img 
                            title={club.name} 
                            onClick={()=> handleClubProfilePictureClick()} 
                            src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClubImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        {!editing && <h2 className={styles.clubName}>{club.name}</h2>}
                        
                        <div className={styles.clubItem} onClick={() => {handleClubOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                 
                                title="options"
                            >
                                ⋮
                            </button>

                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, club._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>

                                    {membership==='member' && <button 
                                        onClick={() => 
                                        {handleLeaveClub(club._id);setShowOptions(null)}}>
                                            <LeaveGroupIcon/>
                                            Leave Club
                                        </button>
                                    }
                                    <button 
                                    onClick={() => {handleReportClubPopup(club._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Club
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className={styles.bottom}>
                            {clubProfilePictureView && (
                                <div className={ styles.clubProfilePictureViewOverlay}>
                                    <h3>{club.name}</h3>
                                    <img 
                                        title={club.name} 
                                        src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultClubImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    {club.admin == userId &&( 
                                    <p onClick={()=>handleClubProfilePictureEdit()} >
                                        <EditIcon className={styles.editClubDescriptionIcon}/>
                                    </p>)}
                                    <button onClick={()=>handleClubProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                            
                        {editing ?
                            (<div className={styles.editDescriptionContainer}>
                                <input
                                type="text"
                                className={styles.clubNameInput}
                                value={club.name || ""}
                                onChange={(e) => setClub({ ...club, name: e.target.value })}
                                placeholder="Enter club name..."
                            />
                                <textarea
                                    className={styles.descriptionTextarea}
                                    value={club?.description || ""}
                                    onChange={(e) => setClub({ ...club, description: e.target.value })}
                                    placeholder="Enter club description..."
                                />
                                <div className={styles.descriptionButtons}>
                                    <button 
                                        className={styles.cancelDescriptionButton}
                                        onClick={() => setEditing(false)}
                                    >
                                        Cancel
                                    </button>
                                    <button 
                                        className={styles.saveDescriptionButton}
                                        onClick={() => {setEditing(false);handleSaveClubInfo()}}
                                    >
                                        Save
                                    </button>
                                    </div>
                            </div>)
                            :
                            (
                                <>
                                <p className={styles.clubDescription}>{club.description || "No description Info"}
                                </p>
                                {club.admin == userId &&( 
                                <p  className={styles.editClubDescriptionIcon} onClick={()=>setEditing(!editing)} >
                                    <EditIcon/>
                                </p>)}
                                </>
                            )
                        }

                        {clubProfilePicturePopup && (
                                <div>
                                    <h3>Select Avatar</h3>
                                    <div className={styles.profilePictureGrid}>
                                        {GROUPAVATARS.map((defaultClubImage, index) => (
                                            <img 
                                                key={index}
                                                src={defaultClubImage} 
                                                alt={`Avatar ${index + 1}`} 
                                                onClick={() => handleProfilePictureSelect(defaultClubImage)} 
                                                className={styles.gridImage}
                                            />
                                        ))}
                                    </div>

                                    <div className={styles.profileInfo}>
                                        <label>Custom Upload</label>
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={(e) => handleUpload(e, 'profilePicture')}
                                            className={styles.imageUploadInput}
                                        />
                                        {uploading && <p>Uploading...</p>}
                                    </div>
                                    
                                    <div className={styles.clubProfilePicturePopupCloseButton}>
                                        <button onClick={() => setClubProfilePicturePopup(false)} disabled={closeButton} className={styles.clubProfilePicturePopupCloseButton}>Close</button>
                                    </div>
                                </div>
                        )}
                        
                        <span className={styles.clubCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleClubChatClick(club)} className={styles.primaryAction}>
                                <GroupMessageIcon /> 
                                <p> Say Hi! </p>
                            </button>
                            <button onClick={() => handleLeaveClubClick(club._id)} className={styles.secondaryAction}>
                                😢Leave Club
                            </button>
                                        <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {club.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>
                        
                         <SocialSearch socialType="club" socialId={clubId} />

                        {club.admin == userId ? (
                            <ul className={styles.memberList}>
                                {club.participants.map((member, index) => (
                                    <>
                                        <li key={member} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                            <img title={member.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                            <p>{member.name}</p>
                                            </li>
                                        <button onClick={() => handleRemoveMember(club._id, member._id)} className={styles.removeMemberButton} aria-label={`Remove ${member.name} from club`} title="Remove member">
                                            X
                                        </button>
                                    </>
                                ))}
                            </ul>
                            ) : (
                            <ul className={styles.memberList}>
                                {club.participants.map((member, index) => (
                                    <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                        <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                        <p>{member.name}</p>
                                        </li>
                                ))}
                            </ul>
                        )}

                        {club.admin == userId ? (
                            <button onClick={handleShowAddMembers} className={styles.addMembers}>
                                Add Members
                            </button>
                        ) : null}

                        {showAddMembers && (
                            <div className={styles.mainContent}>
                                <div className={styles.leftColumn}>
                                    <div className={styles.clubCreationForm}>
                                        <h4>🌈 Adding {selectedNetworks.length} New Member(s) to {club.name}🌈</h4>
                                        <button onClick={()=>handleAddMembers(club._id)} className={styles.createButton}>
                                            🎊 Add Selected Members! 🎊
                                        </button>
                                        <button onClick={handleShowAddMembers} className={styles.closeCreateClubButton}>
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                                <div className={styles.rightColumn}>
                                    {(availableNetworks || availableNetworks.length !== 0) &&  (
                                        <div className={`${styles.networksSection} ${styles.pnClub}`}>
                                            <h3>Add Friends</h3>
                                            <ul>
                                                {availableNetworks?.map(network => (
                                                    <li key={network._id} className={styles.networkItem} 
                                                    onClick={(e) => handleSelectNetwork(e, network._id)}
                                                    >
                                                        <div className={styles.networkInfo} >
                                                            <img title={network.name} src={network.profilePicture ? network.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                                            <span className={styles.networkName}>💫 {network.name} 💫</span>
                                                            <span className={styles.connectionTime}>{network.skills}</span>
                                                            <input type="checkbox" checked={selectedNetworks.includes(network._id)}/>
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                            {(!availableNetworks || availableNetworks.length === 0) && (
                                            <div className={styles.emptyState}>
                                                <p>🥺All Your Connection are in this club? Let's find some amazing people to connect with! 🥺</p>
                                            </div> 
                                            )}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}
                        
                    </div>
                }
                {leaveClubPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Leave Club</h2>
                            <p>Are you sure you want to leave this club?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmLeaveClub} className={styles.confirmButton}>Yes, Leave</button>
                                <button onClick={cancelLeaveClub} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {activeClubChat && (
                    <SocialMessageBox socialType={socialType} social={activeClubChat} onClose={handleCloseChat} />
                )}
                </>
            )}
            {membership == 'guest'&&(
                <>
                {club &&
                    <div className={styles.clubProfileContainer}>
                        <img 
                            title={club.name} 
                            onClick={()=> handleClubProfilePictureClick()} 
                            src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClubImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        <div className={styles.clubItem} onClick={() => {handleClubOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                title="options"
                            >
                                ⋮
                            </button>
                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, club._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>
                                    <button 
                                    onClick={() => {handleReportClubPopup(club._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Club
                                    </button>
                                </div>
                            )}
                        </div>

                        <div className={styles.bottom}>
                            {clubProfilePictureView && (
                                <div className={ styles.clubProfilePictureViewOverlay}>
                                    <h3>{club.name}</h3>
                                    <img 
                                        title={club.name} 
                                        src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultClubImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    <button onClick={()=>handleClubProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                        <p className={styles.clubDescription}>{club.description || "No description Info"}</p>
                        <span className={styles.clubCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleJoinClub(club._id)} className={styles.primaryAction}>
                                <p> Join Club </p>
                            </button>
                            <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {club.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>

                        <ul className={styles.memberList}>
                            {club.participants.map((member, index) => (
                                <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                    <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                    <p>{member.name}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                }

                {leaveClubPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Leave Club</h2>
                            <p>Are you sure you want to leave this club?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmLeaveClub} className={styles.confirmButton}>Yes, Leave</button>
                                <button onClick={cancelLeaveClub} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {/* {activeClubChat && (
                    <ClubChatMessages club={activeClubChat} onClose={handleCloseChat} />
                )} */}
                </>
            )}
            {membership == 'left'&&(
                <>
                {club &&
                    <div className={styles.clubProfileContainer}>
                        <img 
                            title={club.name} 
                            onClick={()=> handleClubProfilePictureClick()} 
                            src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultClubImage2}alt="pfp" 
                            className={`${styles.networkProfilePicture} ${styles.top}`} 
                        />
                        <h2 className={styles.clubName}>{club.name}</h2>
                        
                        <div className={styles.clubItem} onClick={() => {handleClubOptions()}}>
                            <button 
                                className={styles.threeDotsButton} 
                                 
                                title="options"
                            >
                                ⋮
                            </button>

                            {showOptions === true && (
                                <div className={styles.messageOptionsMenu}>
                                    <button 
                                    onClick={(e) => 
                                    {handleCopyInviteLink(e, club._id);setShowOptions(null)}}>
                                        <CopyLinkIcon/>
                                        Copy Invite Link
                                    </button>
                                    <button 
                                    onClick={() => {handleDeleteClubClick(club._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Delete Club
                                    </button>
                                    <button 
                                    onClick={() => {handleReportClubPopup(club._id);setShowOptions(null)}}>
                                        <ReportIcon/>
                                        Report Club
                                    </button>
                                </div>
                            )}
                            </div>
                        <div className={styles.bottom}>
                            {clubProfilePictureView && (
                                <div className={ styles.clubProfilePictureViewOverlay}>
                                    <h3>{club.name}</h3>
                                    <img 
                                        title={club.name} 
                                        src={club.profilePicture ? club.profilePicture.replace('/upload/', '/upload/w_288,h_300,c_fill/') : defaultClubImage2}alt="pfp" 
                                        className={styles.networkProfilePictureLarge} 
                                    />
                                    <button onClick={()=>handleClubProfilePictureClick()} className={styles.closeProfilePictureViewButton}>Close</button>
                                </div>
                            )}  
                        </div>

                        <p className={styles.clubDescription}>{club.description || "No description Info"}
                        </p>
                        
                        <span className={styles.clubCreated}>Created: {createdDate}</span>
                        <div className={styles.networkActions}>
                            <button onClick={() => handleJoinClub(club._id)} className={styles.primaryAction}>
                                Rejoin Club
                            </button>
                            <button className={styles.secondaryAction} onClick={() => handleBack()} > Go Back </button>
                            <br/><br/>
                        </div> 
                        
                        <div className={styles.sectionTitle}>
                            <h3 >  </h3>
                            <h3 className={styles.sectionTitleParticipantsNumber}> {club.participants.length} </h3>
                            <h3 >Members</h3>
                        </div>

                        <ul className={styles.memberList}>
                            {club.participants.map((member, index) => (
                                <li key={member._id?.toString()} className={styles.memberItem} onClick={() => handleProfileClick(member._id)}>
                                    <img title={member._id?.name} src={member.profilePicture ? member.profilePicture.replace('/upload/', '/upload/w_192,h_200,c_fill/') : defaultProfile2}alt="pfp" className={styles.networkProfilePicture} />
                                    <p>{member.name}</p>
                                </li>
                            ))}
                        </ul>
                            
                    </div>
                }
                {deleteClubPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Confirm Delete Club</h2>
                            <p>Are you sure you want to delete this club?</p>
                            <div className={styles.popupActions}>
                                <button onClick={confirmDeleteClub} className={styles.confirmButton}>Yes, Delete</button>
                                <button onClick={cancelDeleteClub} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}
                {/* {activeClubChat && (
                    <ClubChatMessages socialType={socialType} social={activeClubChat} onClose={handleCloseChat} />
                )} */}
                </>
            )}
            {reportClubPopup && (
                    <div className={styles.popupOverlay}>
                        <div className={styles.popupContent}>
                            <h2>Reporting Club</h2>
                            <p>Thanks, Reported Club are reviewed shortly.</p>
                                <textArea
                                    type="text"
                                    value={reportMessage}
                                    onChange={(e) => setReportMessage(e.target.value)}
                                    placeholder="Report Message (Optional)"
                                    className={styles.reportMessageInput}
                                />
                            <div className={styles.popupActions}>
                                <button onClick={(e)=>handleReportClub(e, reportClubId)} className={styles.confirmButton}>Report</button>
                                <button onClick={cancelReportClub} className={styles.cancelButton}>Cancel</button>
                            </div>
                        </div>
                    </div>
                )}

        </div>
    );
}
export default ClubProfile;